import React, { useState, useRef,useEffect,useContext } from "react";
import { IconButton, Tooltip, Popper, Paper, List, ListItem, ListItemText, ClickAwayListener, Divider, Typography,Snackbar,Alert } from "@mui/material";
import BookmarkIcon from "@mui/icons-material/Bookmarks";
import { useNavigate } from "react-router-dom";
import { getBasePathBasedOnChartType } from "../../common/utility/helperFunc";
import EditIcon from '@mui/icons-material/EditNote';
import { useAxiosWithAuth } from "../../common/api/hooks/useAxiosWithAuth";
import { URL } from "../../common/api/urls";
import { SNACKBAR_AUTO_HIDE_DURATION, TEXT_MSGS } from "../../common/utility/constant";
import AppErrorPopup from '../AppErrorPopup';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CreateWatchlistDialog from "../../pages/dashboard/components/create_watchlist";
import EditIconRename from '@mui/icons-material/Edit';
import { WATHCLIST_COUNT_ALLOWED } from "../../common/utility/mp_chart_constants";
import DeleteIcon from '@mui/icons-material/Delete';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ConfirmActionDialog from "../../pages/dashboard/components/confirm_dialog";
import { UserSettingsContext } from "../../setup/routes-manager/RequireAuth";
import usePermissions from "../../common/hooks/usePermissions";

const WatchlistDropdownComponent = (props) => {
    const navigate = useNavigate();
    const from = "/login";
    //using the new context
  const { refreshWatchlists, setWatchlists, watchlists } = useContext(UserSettingsContext);

    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null); // Reference to IconButton
    const [cancel,responseData, error, loaded, reset,executeAPI ] = useAxiosWithAuth();
    const [cancelCreate,responseDataCreate, errorCreate, loadedCreate, resetCreate,executeAPICreate ] = useAxiosWithAuth();
    const [cancelDelete,responseDataDelete, errorDelete, loadedDelete, resetDelete,executeAPIDDelete ] = useAxiosWithAuth();
    const [isLoading,setIsLoading]=useState(true);
    const [watchlistData,setWatchListData]=useState({});
    const [selectedWatchListInstrument,setSelectedWatchlistInstrument]=useState([]);
    const selectedWatchList = props.selectedWatchList
    const [openCreateDialog,setOpenCreateDialog]=useState(false);
    const [openDeleteDialog,setOpenDeleteDialog]=useState(false);
    const [deleteWatchlistName,setDeleteWatchlistName]=useState()
    const permissions = usePermissions()

    const [msgState, setMsgState] = useState({
        openSnack: false,
        msg: '',
        severity: 'info',
      })
      const { openSnack, msg, severity } = msgState
      const handleCloseSnack = (event, reason) => {
        setMsgState({ ...msgState, openSnack: false })
      }

    //load bookmarks
  useEffect(()=>{

      if(permissions.canAccessWatchlist()) executeAPI(URL.GET_WATCHLIST,"GET",{})
    // executeAPITest(URL.GET_GLOBAL_BOOKMARK+"?global_id=2acfa596-1385-4497-8167-e88fbfdc9ec3","GET",{})
  },[])

//   useEffect(()=>{
// //call the watchlist component and load the data
//     console.log("watchlist in dropdown=",selectedWatchList,selectedWatchListInstrument)
//     props.onChange(selectedWatchList,selectedWatchListInstrument);
//   },[selectedWatchList])

  useEffect(()=>{
    if(loaded){
      console.log("Watch list get ========>",responseData,deleteWatchlistName,selectedWatchList);
      if(responseData!=null){
       setIsLoading(false);
       if(responseData.data){
        setWatchListData(responseData.data);
        setWatchlists?.(responseData.data);
        if(!deleteWatchlistName ||(deleteWatchlistName && deleteWatchlistName==selectedWatchList)){
            console.log("Watch list get ========> inside")
        const keys = Object.keys(responseData.data);
          const target = (props.selectedWatchList && keys.includes(props.selectedWatchList))
          ? props.selectedWatchList
          : keys[0];
        setSelectedWatchlistInstrument(responseData.data[target])
  // in the loaded useEffect
        props.onChange(target, responseData.data[target]);
  
  }
        setDeleteWatchlistName(undefined);
       }

       }else if(error!==null){
        setIsLoading(false);

        console.log("Error data=",error);
        
       
        // setMsgState({open:true,msg:errorAutoSave?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"error"});
        if(error?.response?.status === 401 || error?.response?.status === 403){
          console.log("status received =",error?.response?.status)
          navigate(from, { replace: true });
        }else{
          setMsgState({open:true,msg:error?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"error"});
        }
      }
      reset();
      
    }

  },[loaded,responseData])

    const handleToggle = () => {
        setOpen((prev) => !prev);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    const handleManageClick = () => {
      const currentWatchlists = watchlists ?? watchlistData ?? {};
      const numberOfKeys = Object.keys(currentWatchlists).length;
        console.log("snack watchlistData",numberOfKeys)

        if(numberOfKeys>WATHCLIST_COUNT_ALLOWED)
            setMsgState({openSnack:true,msg:`${WATHCLIST_COUNT_ALLOWED}${TEXT_MSGS.MAX_WATCHLIST_ALLOWED}`,severity:"warning"});
       else
        setOpenCreateDialog(true)
    };


    const openWatchlist = (event, item) => {
        setOpen(false);
        const basePath = getBasePathBasedOnChartType(item.chartType)
        console.log("GlobalBK openBookmark item=", item, item.chartType, item.id, basePath)

        const url = `${process.env.REACT_APP_URL}${basePath}?globalBookmarkID=${item.id}`

        if (event.ctrlKey || event.metaKey) {
            window.open(`${url}`, '_blank', 'noreferrer');
        } else {
            window.location.href = url;
        }

    }
    const cancelSaveHandler=()=>{
        setOpenCreateDialog(false)
      }
    
      const createWatchlist=(name)=>{
        console.log("GlobalBK Dialog save called name=",name);
        setOpenCreateDialog(false);
        // saveAsBookamrk(name);
        let data={
          [name]:[]
        }
        executeAPICreate(URL.CREATE_WATCHLIST,"POST",data);
      }
      useEffect(()=>{
        if(loadedCreate){
          console.log("Watch list created ========>",responseDataCreate);
          if(responseDataCreate!=null){
            setMsgState({open:true,msg:`${TEXT_MSGS.WATCHLIST_CREATED}`,severity:"success"});
            executeAPI(URL.GET_WATCHLIST,"GET",{})
            refreshWatchlists?.();   // <-- add this
            //now all teh watchlist subsribers will get the updated wathclist
           }else if(errorCreate!==null){
            setIsLoading(false);
    
            console.log("Error data=",errorCreate);
            
           
            // setMsgState({open:true,msg:errorAutoSave?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"error"});
            if(errorCreate?.response?.status === 401 || errorCreate?.response?.status === 403){
              console.log("status received =",errorCreate?.response?.status)
              navigate(from, { replace: true });
            }else{
              setMsgState({open:true,msg:errorCreate?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"error"});
            }
          }
          resetCreate();
          
        }
    
      },[loadedCreate,responseDataCreate])

      const handleDeleteWatchlist=(key)=>{
        console.log("Watchlist delete called=",key)
           setDeleteWatchlistName(key);
          setOpenDeleteDialog(true)
      }

      const confirmDelete=()=>{
        setOpenDeleteDialog(false)
        let data={
            name_key:deleteWatchlistName
          }
        executeAPIDDelete(URL.DELETE_WATCHLIST,"DELETE",data);
      }

      useEffect(()=>{
        if(loadedDelete){
          console.log("Watch list created ========>",responseDataDelete);
          if(responseDataDelete!=null){
            setMsgState({open:true,msg:`${TEXT_MSGS.WATCHLIST_DELETED}`,severity:"success"});
            setWatchlists?.((prev) => {
              const next = { ...(prev || {}) };
              delete next[deleteWatchlistName];
              return next;
            });
            // // if(selectedWatchList==deleteWatchlistName){
            // setSelectedWatchlistInstrument(responseData.data[firstKey])
            // setSelectedWatchlist(firstKey)
          
            executeAPI(URL.GET_WATCHLIST,"GET",{})
            refreshWatchlists?.();   // subscribers will get the updated watchlist now

           }else if(errorCreate!==null){
           
            // setMsgState({open:true,msg:errorAutoSave?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"error"});
            if(errorDelete?.response?.status === 401 || errorDelete?.response?.status === 403){
              console.log("status received =",errorDelete?.response?.status)
              navigate(from, { replace: true });
            }else{
              setMsgState({open:true,msg:errorDelete?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"error"});
            }
          }
          resetDelete();
          
        }
    
      },[loadedDelete,responseDataDelete])

    return (
        <>
            <IconButton
                ref={anchorRef}
                onClick={handleToggle}
                sx={{
                    mr: 1,
                    borderRadius: 1, // makes it more rectangular (theme.spacing(1))
                    paddingX: 1.5, // horizontal padding for better shape
                    paddingY: 0.5,
                    backgroundColor: 'transparent',
                    '&:hover': {
                      backgroundColor: '#4278d7', // light hover background
                    },
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5,
                  }}
                size="small"
                edge="start"
                aria-label="watchlist"
            >
            
              {Object.keys(watchlists ?? watchlistData ?? {}).length === 0?
                <>
                <Typography>Watchlist</Typography>
                <ArrowDropDownIcon></ArrowDropDownIcon>
                </>
                :
                <>
                <Typography>{selectedWatchList ? selectedWatchList:"NA"}</Typography>
                <ArrowDropDownIcon></ArrowDropDownIcon>
                </>
                    }
                {/* <Tooltip title="Global Bookmarks">
                    <BookmarkIcon sx={{ color: "primaryTheme.shade01", width: "24px", height: "24px" }} />
                </Tooltip> */}
            </IconButton>
                  
            {/* Popper for showing the list below the button */}
            {/* <Popper open={open} anchorEl={anchorRef.current} placement="bottom-start" style={{ zIndex: 1300,mr:-8 }}> */}
            <Popper
                open={open}
                anchorEl={anchorRef.current}
                placement="bottom-end"
                style={{ zIndex: 1300, transform: "translateX(-20px)" }} // Moves it 20px left
            >
                <ClickAwayListener onClickAway={handleClose}>
                    <Paper
                        elevation={3}
                        sx={{
                            pl: 1,
                            pr: 1,
                            pb: 1,
                            minWidth: 240,
                            maxHeight: 340,  // Limit height to 400px
                            overflowY: "auto" // Enable scrolling when content overflows
                        }}
                    >
                        <List>
                            {/* Manage Bookmark Button */}
                            <ListItem
                                button
                                onClick={handleManageClick}
                                sx={{
                                    fontWeight: "bold",
                                    color: "primary.main",
                                    position: "sticky",
                                    top: 0,
                                    backgroundColor: "#0d203f",
                                    zIndex: 1
                                }}
                            >
                                <ListItemText
                                    primary={
                                        <Typography variant="body1" sx={{ fontSize: "14px", fontWeight: "bold" }}>
                                            Create Watchlist 
                                            <EditIcon sx={{color: "#ffffff",ml:0.4,mt:0,mb:-0.3,width:18,height:18}}></EditIcon>
                                        </Typography>
                                    }
                                />
                            </ListItem>
                            <Divider /> {/* Adds a separator */}
                            {/* {watchlistData.length > 0 ? (
                                watchlistData.map((watchlist) => ( */}
                            {Object.entries(watchlists ?? watchlistData ?? {}).map(([key, values]) => (
                                    <ListItem 
                                    button 
                                    key={key} 
                                    onClick={(event) =>{ 
                                    const currentWatchlists = watchlists ?? watchlistData ?? {};
                                        setSelectedWatchlistInstrument(currentWatchlists[key]);
   
                                    props.onChange(key, currentWatchlists[key]);

                                        handleClose(event);
                                    }}
                                    secondaryAction={
                                      <>
                                          <IconButton
                                              edge="end"
                                              aria-label="rename"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                props.onRenameRequest(key);
                                              }}
                                            >
                                              <Tooltip title={`Rename ${key}`} placement="right">
                                                <EditIconRename fontSize="small" sx={{ color: "#ffffff" }} />
                                              </Tooltip>
                                          </IconButton>
                                        <IconButton
                                          edge="end"
                                          aria-label="delete"
                                          onClick={(e) => {
                                            e.stopPropagation(); // prevent triggering parent ListItem's onClick
                                            handleDeleteWatchlist(key);
                                          }}
                                          >
                                            <Tooltip title={`Delete ${key}`} placement="right">
                                          <DeleteIcon fontSize="small"  sx={{color: "#e24747"}}/>
                                          </Tooltip>
                                          
                                        </IconButton>
                                          </>
                                      }
                                    >
                                      <ListItemText
                                      sx={{ minWidth: 0, pr: 1 }} // minWidth:0 is the actual fix — flex children default to min-width:auto and refuse to shrink
                                      primary={
                                        <Tooltip title={key}>
                                          <Typography
                                            variant="body2"
                                            noWrap
                                            sx={{
                                              fontSize: "12px",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            {key}
                                          </Typography>
                                        </Tooltip>
                                      }
                                    />
                                    </ListItem>
                                )
                                )
                            }
                           
                            
                        </List>
                    </Paper>
                </ClickAwayListener>
            </Popper>
            <AppErrorPopup
              open={openSnack}
              message={msg}
              severity={severity}
              onClose={handleCloseSnack}
              showCloseX
            />
            {/* Legacy snackbar (replaced by AppErrorPopup)
            <Snackbar
        onClose={handleCloseSnack}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={openSnack}
        autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION}
        sx={{zIndex:99999}}
      >
        <Alert
          severity={severity}
          sx={{ width: { mobile: '80%', tablet: '70%', laptop: '40%' } }}
        >
          {msg}
        </Alert>
      </Snackbar>
      */}
            {openCreateDialog?
     <CreateWatchlistDialog title={"Create Watchlist"} open={true} cancelHandler={cancelSaveHandler} saveHandler={createWatchlist} ></CreateWatchlistDialog>    :
     <></>
    }
    {/* {renameDialogOpen ?
  <CreateWatchlistDialog
    title={"Rename Watchlist"}
    name={renameOldName}
    isRename
    open={true}
    cancelHandler={() => setRenameDialogOpen(false)}
    saveHandler={(newName) => renameWatchlist(newName)}
  /> :
  <></>
} */}
      {openDeleteDialog?
      <ConfirmActionDialog open={true} cancelHandler={()=>setOpenDeleteDialog(false)} saveHandler={()=>confirmDelete()} 
          title={deleteWatchlistName ? `${TEXT_MSGS.DELETE_WATCHLIST_TITLE}: ${deleteWatchlistName}` : TEXT_MSGS.DELETE_WATCHLIST_TITLE} description={TEXT_MSGS.DELETE_WATCHLIST_MSG}></ConfirmActionDialog>    :
      <></>
      }  
        </>
    );
};

export default WatchlistDropdownComponent;
